<div class="list-group" *appRole="['Contratos.Ver']">
    <button type="button" [routerLinkActive]="['active']" routerLink='/contratos/{{idContrato}}' class="list-group-item list-group-item-action">
        <div class="with-icon">
        <mat-icon class="padding-icon">gavel</mat-icon><span >Contrato</span>
        </div>
    </button>
    <button type="button" [routerLinkActive]="['active']" routerLink='/periodoshistoricos/{{idContrato}}' class="list-group-item list-group-item-action">
      <div class="with-icon">
        <mat-icon class="padding-icon">history</mat-icon> <span >Periodos Historicos</span>
      </div>
    </button>
   <button type="button" *appRole="['Documentos.Ver']" [routerLinkActive]="['active']" routerLink='/documentoscontrato/{{idContrato}}' class="list-group-item list-group-item-action">
      <div class="with-icon">
        <mat-icon class="padding-icon">folder</mat-icon> <span >Documentos</span>
      </div>
    </button>
    <button type="button" [routerLinkActive]="['active']" routerLink='/archivostemporalescontrato/{{idContrato}}' class="list-group-item list-group-item-action">
      <div class="with-icon">
        <mat-icon class="padding-icon">source</mat-icon> <span >Archivos Temporales</span>
      </div>
    </button>

    <button type="button" *appRole="['Movimientos.Ver']" [routerLinkActive]="['active']" routerLink='/movimientosscontrato/{{idContrato}}' class="list-group-item list-group-item-action">
      <div class="with-icon">
        <mat-icon class="padding-icon">account_balance</mat-icon> <span >Movimientos</span>
      </div>
    </button>
    <button type="button" *appRole="['Comprobantes.Ver']" [routerLinkActive]="['active']" routerLink='/comprobantescontrato/{{idContrato}}' class="list-group-item list-group-item-action">
      <div class="with-icon">
        <mat-icon class="padding-icon">wysiwyg</mat-icon> <span >Comprobantes</span>
      </div>
    </button>
</div>
